import './PendingSettingsIndicator.scss';

export interface IAdditionalSettings {
  total: number;
  toBeCompleted: number;
  completed: number;
  notCompleted: number;
  withUnconfirmedActions: number;
  remainingMPNs: number;
}
interface PendingSettingsIndicatorProps {
  totalAdditionalSettings: IAdditionalSettings;
}

interface IAlert {
  type: 'pending' | 'pendingConfirmation' | 'success' | 'canceled';
  show?: boolean;
  text: string;
  color: string;
  bgColor: string;
}

const PendingSettingsIndicator = ({
  totalAdditionalSettings: { remainingMPNs, toBeCompleted, completed, notCompleted, withUnconfirmedActions }
}: PendingSettingsIndicatorProps) => {
  const alertList: IAlert[] = [
    {
      type: 'pending',
      show: remainingMPNs > 0,
      text: `${remainingMPNs} pendientes de MPN ●`,
      color: 'redText',
      bgColor: 'redBackground'
    },
    {
      type: 'pending',
      show: toBeCompleted > 0,
      text: `${toBeCompleted} Configuraciones pendientes ●`,
      color: 'yellow',
      bgColor: 'yellowBackground'
    },
    {
      type: 'pendingConfirmation',
      show: withUnconfirmedActions > 0,
      text: `${withUnconfirmedActions} Configuraciones completadas sin confirmar ●`,
      color: 'purpleText',
      bgColor: 'purpleBackground'
    },
    {
      type: 'success',
      show: completed > 0,
      text: `${completed} Configuraciones completadas ●`,
      color: 'greenText',
      bgColor: 'greenBackground'
    },
    {
      type: 'canceled',
      show: notCompleted > 0,
      text: `${notCompleted} Configuraciones no completadas ●`,
      color: 'redText',
      bgColor: 'redBackground'
    }
  ];

  if (
    toBeCompleted === 0 &&
    completed === 0 &&
    notCompleted === 0 &&
    withUnconfirmedActions === 0 &&
    remainingMPNs === 0
  )
    return null;

  return (
    <>
      {alertList.map((alert, index) => {
        if (!alert.show) return null;
        return (
          <div key={`${alert.type}-${index}`} className="pendingSettingsIndicator">
            <div className={`textIndicator ${alert.color}`}>{alert?.text}</div>
          </div>
        );
      })}
    </>
  );
};

export default PendingSettingsIndicator;
